import './video-player-overlay'
import { user } from './auth';

const netflixDataLimit = 12;

class LibraryLoader {
    static getEndpoint(source, type = null) {
        switch (source) {
            case 'favourite':
                return '/user/favourites';
            case 'recommended':
                return '/user/recommended';
            case 'trending-conversations':
                return '/trending-conversations';
            case 'search':
            default:
                // the type is deprecated. please use source to define the endpoint
                switch (type) {
                    case 'favourite':
                    case 'mosaic-favourite':
                        return '/user/favourites';
                    case 'recommended':
                        return '/user/recommended';
                    default:
                        return '/search_advance';
                }
        }
    }

    constructor(endpoint, limit = netflixDataLimit) {
        this.endpoint = endpoint;
        this.limit = limit;
        this.offset = 0;
        this.loading = false;
        this.parameters = {};
        this._request = null;
        this._requested = null;
    }

    set tags(tags) {
        this.parameters.t = JSON.stringify(tags);
    }

    set query(query) {
        this.parameters.q = JSON.stringify(query);
    }

    set type(type) {
        this.parameters.type = JSON.stringify(type);
    }

    setParam(key, value) {
        this.parameters[key] = value;
    }

    /**
     * @param {?number} offset
     */
    load(offset = null) {
        if (offset) {
            this.offset = offset;
        }
        const url = this.generateUrl();
        if (this._requested === url) {
            return this._request;
        }
        this._requested = url;
        this.loading = true;
        this._request = $.ajax({
            type: 'GET',
            url,
            dataType: 'json',
        }).then(result => {
            this.loading = false;
            return result;
        });

        return this._request;
    }

    generateUrl() {
        const baseUrl = window.location.origin;
        const url = new URL(`/${currentEnvironment.language}${this.endpoint}`, baseUrl);
        Object.entries(this.parameters).forEach(([key, value]) => {
            url.searchParams.append(key, value);
        });
        url.searchParams.append('offset', this.offset);
        url.searchParams.append('limit', this.limit);
        return url.href;
    }
}

function loadingEffect(element, load = false) {
    const loaderEffect = element.siblings('.netflix-loading');
    const netflixList = element.parent();
    if (load) {
        element.addClass('set-opacity');
        netflixList.addClass('position-relative');
        loaderEffect.addClass('position-loader').css({'display': 'flex'});
    } else {
        element.removeClass('set-opacity');
        loaderEffect.removeClass('position-loader').hide();
    }
}

function isGameLibrary() {
    return $('.btd-module-library').data('type') == 'gameLibrary'
}

// returns split string  glue with ||
function parseDataAttribute(value) {
    let data = null
    if (value) {
        data = value.split('||');
    }
    return data;
}

export function getBgStyling (item, size) {
    let url = (item.image || {})[size];
    //if size not available, try original size as fallback
    if (typeof url !== 'string') {
        url = (item.image || {}).original;
        //if original size not found either, no image for you
        if (typeof url !== 'string') {
            return null;
        }
    }
    //escape apostrophe
    url = url.replace(/'/g, "\\'");
    //wrap url
    return `url('${url}')`;
};

export {LibraryLoader, loadingEffect, isGameLibrary, parseDataAttribute};

$(function () {
    //filter inits
    $(".btd-module-library").each(function (_, module) {
        // set the unique ID for each module
        const $module = $(module);
        const moduleId = $module.attr('id');

        if ($module.is('.hide-wo-login') && !user) {
            return; // skip this module if it requires login and user is not logged in
        }

        // set the variables based on module index
        const filtersSelectedStorageKey = `filtersSelected-${moduleId}`;
        const advancedFiltersSelectedStorageKey = `advancedFiltersSelected-${moduleId}`;
        const filtersAgeStorageKey = `filtersAge-${moduleId}`;

        //Initialization of two types of filter
        const filtersSelected = {sort: $module.data("sortby")};
        const advancedFiltersSelected = {};

        //init filter inputs and badges
        const filterCheckboxes = $('#filter .navbar-nav .filter-dropdown input.form-check-input', $module);
        const filterBadges = $('#filter .navbar-nav .badge', $module);
        //init advanced Filter inputs and badges
        const advancedFilterCheckboxes = $('#advanced-filter input.form-check-input', $module);
        const advancedFilterBadges = $('#advanced-filter .badge', $module);
        const showCommentCounter = !$module.is('.no-counter');

        const libraryType = $module.data("type");

        //helper to create library item html
        const isGameLib = (libraryType === 'gameLibrary');
        // delete the older filter
        deleteFilterOnAge(filtersAgeStorageKey, filtersSelectedStorageKey, advancedFiltersSelectedStorageKey)

        //get basic filter values from storage if possible
        try {
            Object.assign(filtersSelected, JSON.parse(window.localStorage.getItem(filtersSelectedStorageKey)));
        }
        catch (err) {}

        //get advanced filter values from storage if possible
        try {
            Object.assign(advancedFiltersSelected, JSON.parse(window.localStorage.getItem(advancedFiltersSelectedStorageKey)));
        }
        catch (err) {}
        // set the basic filter
        filterCheckboxes.each((i, el) => {
            const type = $(el).data('type');
            const value = $(el).prop('value');
            $(el).prop('checked', (filtersSelected[type] && filtersSelected[type].includes(value)) || false);

            if (filtersSelected[type]) {
                filterBadges.filter(`[data-type="${type}"]`).html(typeof filtersSelected[type] === 'string' ? 1 : filtersSelected[type].length);
            }
        });

        // advanced filter button config as it is used bootstrap modal button
        const advanceFilterButton = $("li.nav-item:not(.dropdown) a.nav-link", $module);
        const advanceFilterTarget = advanceFilterButton.attr('data-bs-target');
        advanceFilterButton.attr('data-bs-target', `${advanceFilterTarget}-${moduleId}`);
        // advanced filter list config as it is used bootsrap modal
        const advanceFilterContainer = $("#collapseAdvancedFilterWrapper .collapseAdvancedFilter", $module);
        const advanceFilterTargetId = advanceFilterContainer.attr('id');
        advanceFilterContainer.attr('id', `${advanceFilterTargetId}-${moduleId}`);
        // set the advanced filter
        advancedFilterCheckboxes.each((i, el) => {
            const advancedType = $(el).closest('#collapseAdvancedFilterWrapper').attr('data-type');
            const type = $(el).data('type');
            const value = $(el).prop('value');
            $(el).prop('checked', (
                advancedFiltersSelected[advancedType]
                && advancedFiltersSelected[advancedType][type]
                && advancedFiltersSelected[advancedType][type].includes(value)
            ) || false);
            if (advancedFiltersSelected[advancedType] && advancedFiltersSelected[advancedType][type]) {
                filterBadges.filter(`[data-type="${type}"]`).html(advancedFiltersSelected[advancedType][type].length);
            }
        });
        filterBadges.filter(`[data-type="advanced"]`).html(advancedFilterCheckboxes.filter(':checked').length || '');

        // filter selection
        filterCheckboxes.on('click', function () {
            const type = $(this).data('type');
            const isRadio = $(this).is('[type="radio"]');
            if (isRadio) {
                const value = $(this).prop('value');
                if (filtersSelected[type] === value) {
                    $(this).prop('checked', false);
                }
            }
            filtersSelected[type] = $(this).closest('.filter-dropdown').find('input:checked').toArray().map(el => $(el).prop('value'));
            const $checked = filtersSelected[type].length;
            if (isRadio) {
                filtersSelected[type] = filtersSelected[type].shift() || null;
            }
            const badge = filterBadges.filter(`[data-type="${type}"]`);
            if ($checked === 0) {
                delete (filtersSelected[type]);
                badge.html('');
            } else {
                badge.html($checked);
                $('#filter .navbar-nav #' + type).addClass('something-selected').css('color', '#060D18');
            }
            try {
                window.localStorage.setItem(filtersSelectedStorageKey, JSON.stringify(filtersSelected));
                updateFiltersAge(filtersAgeStorageKey);
            }
            catch (err) { }
            if (['mosaic', 'mosaic-favourite'].includes(libraryType)){
                loadMosaicData();
            } else {
                loadNetflixData(true);
            }
        });

        $('#filter .navbar-nav .filter-dropdown').on('click', function (e) {
            e.stopPropagation();
        });

        // advanced filter selection
        advancedFilterCheckboxes.on('click', function () {
            const advancedType = $(this).closest('#collapseAdvancedFilterWrapper').attr('data-type');
            const type = $(this).data('type');
            advancedFiltersSelected[advancedType] = advancedFiltersSelected[advancedType] || {};
            advancedFiltersSelected[advancedType][type] = $(this).closest('.accordion-item').find('input:checked').toArray().map(el => $(el).prop('value'));
            const $checked = advancedFiltersSelected[advancedType][type].length;
            const $advancedChecked = $.map(advancedFiltersSelected[advancedType], arr => arr.length).reduce((sum, count) => sum + count);
            const mainBadge = filterBadges.filter(`[data-type="advanced"]`);
            const badge = advancedFilterBadges.filter(`[data-type="${type}"]`);
            if ($checked === 0) {
                delete (advancedFiltersSelected[advancedType][type]);
                badge.html('');
            } else {
                badge.html($checked);
            }
            if ($advancedChecked === 0) {
                mainBadge.html('');
            } else {
                mainBadge.html($advancedChecked);
            }
            try {
                window.localStorage.setItem(advancedFiltersSelectedStorageKey, JSON.stringify(advancedFiltersSelected));
                updateFiltersAge(filtersAgeStorageKey);
            }
            catch (err) {}
            if(['mosaic', 'mosaic-favourite'].includes(libraryType)){
                loadMosaicData();
            } else {
                loadNetflixData();
            }
        });

        $('.collapseAdvancedFilter').on('click', function (e) {
            e.stopPropagation();
        });

        $('body').on('click', function () {
            $('.collapseAdvancedFilter').collapse('hide');
        });

        let libraryModulePage = 1;
        let libraryModuleCount = 0;
        const libraryModulePageSize = Math.max(10, Math.min(1000, parseInt($module.data('pagination'), 10) || 10));
        const mosaic = $('.mosaic:not(.manual)', $module);
        const mosaicSource = mosaic.data('source');
        const mosaicEmpty = $('.mosheadlineaic-empty', $module);
        const mosaicError = $('.mosaic-error', $module);
        const mosaicLoading = $('.mosaic-loading', $module);
        const mosaicMore = $('.mosaic-more', $module);

        const loader = new LibraryLoader(
            LibraryLoader.getEndpoint(mosaicSource, libraryType),
            libraryModulePageSize
        );

        const loadMosaicData = function (loadMore) {
            if (!mosaicSource || mosaicSource === 'search') {
                loader.tags = parseDataAttribute(mosaic.attr('data-tags'));
                loader.query = getFilteredTags(mosaic.attr('data-advanced-type') || null);
                loader.type = parseDataAttribute(mosaic.attr('data-types'));
                loader.setParam('sort', filtersSelected?.sort);
            }

            if (!mosaic.length) {
                return;
            }

            //when loading more, increase the page number. otherwise reset the page number and empty the container.
            if (loadMore) {
                libraryModulePage++;
            } else {
                libraryModulePage = 1;
                mosaic.empty();
            }

            //hide empty msg, error msg, show throbber and more button
            mosaicEmpty.hide();
            mosaicError.hide();
            mosaicLoading.show();
            mosaicMore.hide();

            loader.load((libraryModulePage - 1) * libraryModulePageSize).then(result => {
                if (!result || !result.data) {
                    return;
                }

                //update item count
                libraryModuleCount = result.count || 0;

                //add items to html
                $.each(result.data, (i, item) => {
                    if (!item) {
                        return;
                    }

                    mosaic.append(createItem(item, {
                        wrapLi: true,
                        expanded: false,
                        libraryType,
                        showCommentCounter
                    }));
                });

                //hide loading
                mosaicLoading.hide();

                //show empty msg if no results
                if (libraryModuleCount === 0) {
                    mosaicEmpty.show();
                    $module.addClass('empty').removeClass('non-empty');
                } else {
                    $module.removeClass('empty').addClass('non-empty');
                }

                //show more button if there are more pages
                if (libraryModuleCount > libraryModulePage * libraryModulePageSize) {
                    mosaicMore.show();
                }
            }, err => {
                //if the task was to load the next page, reset the page change
                if (loadMore) {
                    libraryModulePage--;
                }

                //show error msg, hide loading
                mosaicError.show();
                mosaicLoading.hide();

                //show more button if there are more pages
                if (libraryModuleCount > libraryModulePage * libraryModulePageSize) {
                    mosaicMore.show();
                }
            });
        };

        mosaicMore.on('click', e => {
            e.preventDefault();
            loadMosaicData(true);
        });
        loadMosaicData();

        const netflix = $('.netflix', $module);

        const loadNetflixData = function (filter = false) {
            netflix.each((index, el) => {
                el = $(el);
                const netflixEmpty = el.siblings('.netflix-empty');
                const netflixError = el.siblings('.netflix-error');
                const netflixLoading = el.siblings('.netflix-loading');

                //hide empty msg, error msg and show loading, hide list
                netflixEmpty.hide();
                netflixError.hide();
                netflixLoading.show();
                el.hide();

                const netflixAdvancedFiltersType = el.attr('data-advanced-type') || null;

                //get content types
                let offset = 0;
                if (!filter) {
                    offset = el.data('offset') ?? 0
                }
                const elIdx = index;
                el.attr('data-index', elIdx);
                const loader = new LibraryLoader(
                    LibraryLoader.getEndpoint(el.data('source'), libraryType),
                    netflixDataLimit
                );
                if (!el.data('source') || el.data('source') === 'search') {
                    loader.tags = parseDataAttribute(el.attr('data-tags'));
                    loader.query = getFilteredTags(netflixAdvancedFiltersType);
                    loader.type = parseDataAttribute(el.attr('data-types'));
                    loader.setParam('sort', filtersSelected?.sort);
                }
                el.data('loader', loader);
                loader.load(0).then(result => {
                    el.attr('data-loadedslides', result.data.length);
                    el.attr('data-totalslides', result.count);
                    el.attr('data-offset', result.data.length);
                    //empty of previous content first
                    if (el.is('.slick-slider')) {
                        el.slick('unslick').empty();
                    }
                    //show empty msg if no results, also hide loading and stop here
                    if ((result.count || 0) === 0) {
                        el.closest('.netflixWrapper').addClass('empty').removeClass('non-empty');
                        netflixEmpty.show();
                        netflixLoading.hide();
                        return;
                    } else {
                        el.closest('.netflixWrapper').removeClass('empty').addClass('non-empty');
                    }

                    //add items to html
                    $.each(result.data, (i, item) => {
                        if (!item) {
                            return;
                        }
                        el.append(addOpeningVideoPlayer(createItem(item, { wrapLi: false, expanded: true, libraryType, showCommentCounter }), `${moduleId}-${elIdx}`));
                    });

                    if (isGameLib) {
                        gameLibraryModalShow();
                    }
                    //setup slider and show it
                    el.slick({
                        variableWidth: true,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        prevArrow: `
                            <button class="slick-prev" aria-label="Previous" type="button">
                                <img src="/assets/img/icons/icon_dark_arrowprev@3x.svg" alt="Previous" class="dark"/>
                                <img src="/assets/img/icons/icon_light_arrowprev@3x.svg" alt="Previous" class="light"/>
                            </button>`,
                        nextArrow: `
                            <button class="slick-next" aria-label="Next" type="button">
                                <img src="/assets/img/icons/icon_dark_arrownext@3x.svg" alt="Next" class="dark"/>
                                <img src="/assets/img/icons/icon_light_arrownext@3x.svg" alt="Next" class="light"/>
                            </button>`,
                        responsive: [
                            {
                                breakpoint: 1105,
                                settings: {
                                    slidesToShow: 2,
                                }
                            },
                            {
                                breakpoint: 725,
                                settings: {
                                    slidesToShow: 1,
                                }
                            }
                        ],
                    }).show();
                    //hide loading
                    netflixLoading.hide();
                }, err => {
                    //show error msg, hide loading
                    netflixError.show();
                    netflixLoading.hide();
                });
            });
        };

        loadNetflixData();

        netflix.on('click', '.slick-next', function () {
            const el = $(this).parent('.netflix.slick-slider');
            const elIdx = el.data('index');
            const netflixAdvancedFiltersType = el.attr('data-advanced-type') || null;

            nextSlide(
                el,
                elIdx,
                parseDataAttribute(el.attr('data-tags')),
                getFilteredTags(netflixAdvancedFiltersType),
                filtersSelected?.sort,
            )
        });

        netflix.on('swipe', function (event, slick, direction) {
            const el = $(this);
            const elIdx = el.data('index');
            const netflixAdvancedFiltersType = el.attr('data-advanced-type') || null;

            nextSlide(
                el,
                elIdx,
            )
        });

        function nextSlide(slider, elIdx) {
            const loader = slider.data('loader');
            const currentActiveSlide = slider.slick('slickCurrentSlide');
            const slidesToShow = parseInt(slider.slick('slickGetOption', 'slidesToShow'), 10);
            const visibleIndex = currentActiveSlide + slidesToShow + 2;
            const currentOffset = parseInt(slider.attr('data-offset'), 10);
            const totalSlides = parseInt(slider.attr('data-totalslides'), 10);
            let loadedSlides = parseInt(slider.attr('data-loadedslides'), 10);
            const types = slider.attr('data-types');

            if (visibleIndex === loadedSlides && loadedSlides < totalSlides) {
                loadingEffect(slider, true);
                loader.load(currentOffset).then(result => {
                    loadedSlides += result.data.length;
                    slider.attr('data-offset', loadedSlides);
                    slider.attr('data-loadedslides', loadedSlides);
                    $.each(result.data, (i, item) => {
                        if (!item) {
                            return;
                        }
                        if (libraryType === 'gameLibrary') {
                            slider.slick('slickAdd', addOpeningVideoPlayer(createItem(item, {
                                wrapLi: false,
                                expanded: true,
                                libraryType,
                                showCommentCounter
                            }), `${moduleId}-${elIdx}`));
                        } else {
                            slider.slick('slickAdd', createItem(item, {
                                wrapLi: false,
                                expanded: true,
                                libraryType,
                                showCommentCounter
                            }));
                        }

                    });

                    if (isGameLib) {
                        gameLibraryModalShow();
                    }

                    loadingEffect(slider, false);
                });
            }
        }

        // return user selected filtered tags
        function getFilteredTags(advancedFiltersType) {
            let tags = {};
            //merge filter tags into array
            $.each(filtersSelected, (key, data) => {
                if (!$.isArray(data)) {
                    return;
                }
                tags[`main_${key}`] = filterExistingFilterTags(tags[key] || [], data, filterCheckboxes, key);
            });

            if (advancedFiltersType) {
                $.each(advancedFiltersSelected[advancedFiltersType] || {}, (key, data) => {
                    if (!$.isArray(data)) {
                        return;
                    }
                    tags[`advanced_${key}`] = filterExistingFilterTags(tags[key] || [], data, advancedFilterCheckboxes, key);
                });
            }
            return {tags: tags};
        }

        function gameLibraryModalShow() {
            const videoLibraryModal = $('#video-library-modal');
            $(document).on('click', "[data-type='gameLibrary'] .item", function (event) {
                if (event.isPropagationStopped()) {
                    return;
                }
                event.stopPropagation()
                event.preventDefault()
                const elem = $(this)
                const slider = elem.parents('.netflix');
                $('.video-player-overlay__headline').text(
                    elem.find('.text h3').text()
                )

                // set the current element data values
                $('.slider', videoLibraryModal)
                    .attr('data-types', slider.attr('data-types'))
                    .attr('data-tags', slider.attr('data-tags'))
                    .attr('data-offset', slider.attr('data-offset'))
                    .attr('data-loadedslides', slider.attr('data-loadedslides'))
                    .attr('data-totalSlides', slider.attr('data-totalSlides'))

                videoLibraryModal
                    .data('initialId', elem.children('[data-videoId]').data('videoid'))
                    .data('selectedFilterTags', getFilteredTags(false));

                videoLibraryModal.modal('show')
            })
        }
    });

    function deleteFilterOnAge(filtersAgeStorageKey, filtersSelectedStorageKey, advancedFiltersSelectedStorageKey) {
        const filtersAgeMaxSec = 24 * 60 * 60;
        //check filters age in localStorage and delete if too old
        try {
            const filtersAge = parseInt(window.localStorage.getItem(filtersAgeStorageKey), 10);
            if (filtersAge && Date.now() - filtersAge > filtersAgeMaxSec * 1000) {
                window.localStorage.removeItem(filtersSelectedStorageKey);
                window.localStorage.removeItem(advancedFiltersSelectedStorageKey);
                window.localStorage.removeItem(filtersAgeStorageKey);
            }
        } catch (err) {
        }
    }

    //helper to properly check and escape background image urls

    const favouriteIcon = $('<div class="favouriteIcon" />').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 475.82 442.01" version="1.0">\n' +
        '    <path d="M129.35 9.35c-66.24 0-120 53.76-120 120 0 134.75 135.93 170.08 228.56 303.3 87.57-132.4 228.56-172.85 228.56-303.3 0-66.24-53.76-120-120-120-48.05 0-89.4 28.37-108.56 69.18-19.16-40.81-60.52-69.18-108.56-69.18z" stroke="#000" stroke-width="18.7" fill="#79b3dc" fill-opacity="1"></path>\n' +
        '</svg>');

    function createItem(item, options = {}) {
        const { wrapLi = false, expanded = false, libraryType, showCommentCounter = true } = options;
        const bgElements = [];
        const textElements = [];
        const bgSizes = {
            default: '480x270',
            large: '640x360',
            vertical: '320x360',
        };
        $.each(bgSizes, (type, size) => {
            bgElements.push(
                $('<div/>')
                    .addClass('bg')
                    .attr('data-display', type)
                    .css('background-image', getBgStyling(item, size))
            );
        });

        const headline = $('<h3 class="text-ellipsis-2" />')
            .html(item.headline);

        if (expanded) {
            const date = $('<span/>')
                .text(item.date);

            textElements.push(headline);
            textElements.push(date);
            if (['favourite', 'mosaic-favourite'].includes(libraryType)) {
                textElements.push(favouriteIcon.clone());
            }
        } else {
            if (['mosaic', 'mosaic-favourite'].includes(libraryType)) {
                const tag = $('<span class="d-block w-100 text-ellipsis" />').addClass('mosaic-tag').text(item.tag);

                textElements.push(tag);
            }

            textElements.push(headline);

            if (['favourite', 'mosaic-favourite'].includes(libraryType)) {
                textElements.push(favouriteIcon.clone());
            }
        }

        if (showCommentCounter && item.pageType === 'article' && item.commentCount) {
            const commentCount = $('<div class="comment-count" />');
            commentCount.html('<svg class="icon"><use xlink:href="/assets/icons.svg#chat-line"></use></svg>&nbsp;' + item.commentCount);
            textElements.push(commentCount);
        }

        const text = $('<div/>')
            .addClass('text')
            .addClass(expanded ? 'expanded' : null)
            .append(textElements);

        const typeIcon = $('<img/>')
            .addClass('iconContentType')
            .attr('src', `/assets/img/icons/icon_dark_${item.pageType}@3x.svg`)
            .attr('alt', item.pageType);

        const a = $('<a/>')
            .attr('href', item.url);

        const queryArray = item.url.split('/');
        const videoId = queryArray[queryArray.length - 1];

        const videoCard = $('<a/>')
            .attr('href', '#')
            .attr('data-videoid', videoId)
            .attr('data-date', item.date)
            .attr('data-headline', item.headline)
            .attr('data-tag', item.tag)
            .attr('data-imgurl', getBgStyling(item, '640x360'));

        let htmlTag = (libraryType === 'gameLibrary') ? videoCard : a;

        htmlTag
            .attr('title', item.headline)
            .append(bgElements)
            .append(text)
            .append(typeIcon);

        if (['mosaic', 'mosaic-favourite'].includes(libraryType)) {
            return $(wrapLi ? '<li/>' : '<div/>').addClass('item').append(htmlTag);
        }

        return $('<div/>').append($('<div/>').append($(wrapLi ? '<li/>' : '<div/>')
            .addClass('item')
            .append(htmlTag)));
    }

    //add listener on card
    function addOpeningVideoPlayer (elem, sliderUniqueId) {
        elem.find('a').attr('data-sliderUniqueId', `${sliderUniqueId}`)
        return elem
    }

    //helper to only add filter tags if the filter is actually there, to prevent problems from loaded values that don't match the filters on the page
    function filterExistingFilterTags (tags, data, filters, type) {
        return tags.concat(data.filter(tag => {
            return filters.filter(`[data-type='${type.replace(/'/g, "\\'")}'][value='${tag.replace(/'/g, "\\'")}']`).length > 0;
        }));
    };

    //use to update filters age on change
    const updateFiltersAge = (filtersAgeStorageKey) => {
        try {
            window.localStorage.setItem(filtersAgeStorageKey, String(Date.now()));
        } catch (err) {
        }
    };

});
